<template>
  <div class="app-container">
    <!-- 顶部栏 -->
    <div class="topbar" style="padding-top: 20px">
      <div>
        <el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
                  @keyup.enter.native="search()" clearable/>

        <el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
                   style="margin-left: 10px" @click="search()">
          搜索
        </el-button>

      </div>
      <el-button type="success" size="small" @click="export2Excel()">导出excel</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column fixed label="ID" prop="userID" align="center" width="100"></el-table-column>
      <el-table-column fixed label="签到者" prop="userID" align="center" width="150">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column v-for="item in totalSignMsg" :label="getSignTitle(item)" align="center" min-width="200">
        <template #default="scope">
          {{ getUserSignTime(item, scope.row) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination hide-on-single-page background :total="pageOpt.total" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.curPage" @current-change="currentPageChange"/>


  </div>

</template>

<script>
import {getLiveSignListByUser, getLiveSignMsgList} from "@/api/mai/liveManagement/liveManagement";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {handleRes, handleResWithReturn} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {isVaild} from "@/utils/validate";
import {export_json_to_excel} from "@/vendor/Export2Excel";

export default {
  name: "SignListByUser",
  components: {UserInfo},
  props: {
    liveID: {
      type: Number
    }
  },
  data() {
    return {
      navigationKey: "LiveSignListByUser",

      loading: false,
      searchValue: "",
      pageOpt: {
        total: 0,
        curPage: 1,
        pageSize: 10
      },
      tableData: [],
      totalSignMsg: [],//该直播多少轮签到
    }
  },
  created() {
    let navigationItem = getNavigationItemObj(this.navigationKey)
    this.pageOpt.curPage = navigationItem.curPage
    this.searchValue = navigationItem.searchValue

    this.getLiveSignListByUser()
    this.getAllSignMsgCount();
  },
  methods: {
    /**
     * 获取当场直播总共有多少轮签到
     */
    getAllSignMsgCount() {
      getLiveSignMsgList({liveId: this.liveID, pageSize: 0, sortOrder: "asc"}).then(res => {
        handleRes(res, () => {
          this.totalSignMsg = res.data.rows
        })
      })
    },
    /**
     * table 列标题，有签到提示显示签到提示，没有显示签到发起时间
     * @param item
     * @returns {string|*}
     */
    getSignTitle(item) {
      if (isVaild(item.tipContent)) {
        return item.tipContent
      }
      return `发起时间：${this.$options.filters["formatDateTime"](item.createTime)}`
    },
    /**
     * 用户对应的签到时间
     * @param item
     */
    getUserSignTime(curSign, user) {
      for (let i = 0; i < user.liveSignList.length; i++) {
        let item = user.liveSignList[i]
        if (item.liveSignMsgID == curSign.liveSignMsgID) {
          return `${this.$options.filters["formatDateTime"](item.signTime)}`
        }
      }
      return ""
    },
    search() {
      this.refreshList();
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getLiveSignListByUser();
    },
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getLiveSignListByUser();
    },
    getLiveSignListByUser() {
      this.loading = true
      setNavigationItemWithObj(this.navigationKey, {
        curPage: this.pageOpt.curPage,
        searchValue: this.searchValue
      })

      getLiveSignListByUser({
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageIndex: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize,
      }).then(res => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.pageOpt.total = res.data.total
        })
        this.loading = false
      })
    },
    async getAllLiveSignListByUser() {
      this.loading = true

      let res = await getLiveSignListByUser({
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageIndex: 1,
        pageSize: 0,
      })
      this.loading = false
      return res;
    },
    async export2Excel() {
      if (this.tableData.length === 0) {
        this.$message.info('没有要导出数据')
        return;
      }
      let {
        tName,
        tHeader,
        filterValue
      } = this.getExcelInfo()
      let res = await this.getAllLiveSignListByUser()
      let list = this.formatTableData(res.data.rows)
      let data = this.formatJson(filterValue, list)
      export_json_to_excel({
        header: tHeader,
        data,
        filename: tName,
        autoWidth: true,
        bookType: "xlsx",
      })
    },
    getExcelInfo() {
      let tName = '签到统计';
      let tHeader;
      let filterValue;
      tHeader = ['用户ID', '签到者',]
      for (let i = 0; i < this.totalSignMsg.length; i++) {
        tHeader.push(this.getSignTitle(this.totalSignMsg[i]))
      }
      filterValue = [
        'userID',
        'nickname',
      ]
      for (let i = 0; i < this.totalSignMsg.length; i++) {
        filterValue.push(`${i}`)
      }
      return {
        tName,
        tHeader,
        filterValue
      }
    },
    formatTableData(list) {
      let newList = list.map(item => {
        for (let i = 0; i < this.totalSignMsg.length; i++) {
          item[i] = this.getUserSignTime(this.totalSignMsg[i], item)
        }
        return item
      })

      return newList
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
  }
}
</script>

<style scoped>

</style>